import { getApiUrl } from '../config';
import api from './apiService';

export interface SecretAccess {
  id: string;
  label: string;
  service: string | null;
  kind: 'secret' | 'config';
  value?: string;
  usedByRecipe: boolean;
  recipeCount?: number;
  recipes?: Array<{ id: number; name: string }>;
}

export const getSecrets = async (): Promise<SecretAccess[]> => {
  const response = await api.get<SecretAccess[]>(getApiUrl('secrets'));
  return response.data as SecretAccess[];
};

export const createSecret = async (secret: {
  label: string;
  service?: string | null;
  value: string;
  kind: 'secret' | 'config';
}): Promise<{ id: string; label: string; service: string | null; kind: 'secret' | 'config'; value?: string }> => {
  const response = await api.post(getApiUrl('secrets'), secret);
  return response.data as { id: string; label: string; service: string | null; kind: 'secret' | 'config'; value?: string };
};

export const updateSecret = async (
  secretId: string,
  updates: { label?: string; service?: string | null; value?: string; kind?: 'secret' | 'config' }
): Promise<{ id: string; label: string; service: string | null; kind: 'secret' | 'config'; value?: string }> => {
  const response = await api.patch(getApiUrl(`secrets/${secretId}`), updates);
  return response.data as { id: string; label: string; service: string | null; kind: 'secret' | 'config'; value?: string };
};

export const deleteSecret = async (
  secretId: string
): Promise<{ deleted: boolean; affectedRecipes: number }> => {
  const response = await api.delete(getApiUrl(`secrets/${secretId}`));
  return response.data as { deleted: boolean; affectedRecipes: number };
};

export const getRecipeSecretAccess = async (recipeId: number): Promise<SecretAccess[]> => {
  const response = await api.get<SecretAccess[]>(getApiUrl(`secrets/recipes/${recipeId}`));
  return response.data as SecretAccess[];
};

export const saveConversationSecret = async (
  conversationId: string,
  messageId: string,
  value: string
): Promise<{ id: string; label: string; service: string | null }> => {
  const response = await api.post(getApiUrl(`secrets/conversations/${conversationId}/messages/${messageId}/save`), { value });
  return response.data as { id: string; label: string; service: string | null };
};

export const moveConversationSecretFromRecipe = async (
  conversationId: string,
  messageId: string
): Promise<{ id: string; label: string; service: string | null; recipeUpdated: boolean }> => {
  const response = await api.post(getApiUrl(`secrets/conversations/${conversationId}/messages/${messageId}/move-from-recipe`), {});
  return response.data as { id: string; label: string; service: string | null; recipeUpdated: boolean };
};
